import {
  GetCmsEsperaDocumentacion,
  PostCmsVerificarDocumentacion,
  PutCmsInstructorPrincipal
} from "../../reducers/comisionesV2";

export interface ComisionesDeportivaAppGestionStore
  extends GetCmsEsperaDocumentacion,
    PutCmsInstructorPrincipal,
    PostCmsVerificarDocumentacion {
  archivoRefreshLoading: boolean;
  archivoRefresh: any;
  cincelFirmasLoading: boolean;
}

export const comisionesDeportivaAppGestionStore: (
  state
) => ComisionesDeportivaAppGestionStore = state => {
  const { comisionesV2, expedientes } = state;
  return {
    cmsEsperaDocumentacion: comisionesV2.cmsEsperaDocumentacion,
    gettingCmsEsperaDocumentacion: comisionesV2.gettingCmsEsperaDocumentacion,
    gettingCmsEsperaDocumentacionError:
      comisionesV2.gettingCmsEsperaDocumentacionError,

    puttingCmsInstructorPrincipal: comisionesV2.puttingCmsInstructorPrincipal,
    puttingCmsInstructorPrincipalError:
      comisionesV2.puttingCmsInstructorPrincipalError,

    postingCmsVerificarDocumentacion:
      comisionesV2.postingCmsVerificarDocumentacion,
    postingCmsVerificarDocumentacionError:
      comisionesV2.postingCmsVerificarDocumentacionError,

    archivoRefreshLoading: expedientes.archivoRefreshLoading,
    archivoRefresh: expedientes.archivoRefresh,

    cincelFirmasLoading: expedientes.cincelFirmasLoading
  };
};
